import { Tooltip } from "components/common/Tooltip";
import type { ExportImpactCountProps } from "./types";

export const ExportImpactCount = ({
  totalLabel,
  exportLabel,
  tooltip,
}: ExportImpactCountProps) => {
  return (
    <Tooltip label={tooltip}>
      <span className="flex-shrink-0 whitespace-nowrap text-gray-500">
        (<span className="text-gray-400 line-through">{totalLabel}</span>{" "}
        <span className="font-semibold text-amber-700">{exportLabel}</span>)
      </span>
    </Tooltip>
  );
};
